import { render, staticRenderFns } from "./trainOnline.vue?vue&type=template&id=04065c55&scoped=true&"
import script from "./trainOnline.vue?vue&type=script&lang=js&"
export * from "./trainOnline.vue?vue&type=script&lang=js&"
import style0 from "./trainOnline.vue?vue&type=style&index=0&id=04065c55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04065c55",
  null
  
)

export default component.exports